await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/frontend-js-components-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import {render} from '@liferay/frontend-js-react-web';
import React from 'react';

import SimpleInputModal, {
	SimpleInputModalProps,
} from '../components/SimpleInputModal';

import type {Root} from 'react-dom/client';

const DEFAULT_MODAL_CONTAINER_ID = 'modalContainer';

const DEFAULT_RENDER_DATA = {
	portletId: 'UNKNOWN_PORTLET_ID',
};

let container: HTMLDivElement | null = null;
let root: Root | null = null;

export default function openSimpleInputModalImplementation({
	alert,
	buttonSubmitLabel,
	center,
	checkboxFieldLabel,
	checkboxFieldName,
	checkboxFieldValue,
	dialogTitle,
	formSubmitURL,
	idFieldName,
	idFieldValue,
	mainFieldComponent,
	mainFieldLabel,
	mainFieldName,
	mainFieldPlaceholder,
	mainFieldValue,
	method,
	namespace,
	onFormSuccess,
	required,
	size,
}: SimpleInputModalProps) {
	const cleanUp = () => {
		if (container && root) {
			root.unmount();

			document.body.removeChild(container);

			root = null;
			container = null;
		}
	};

	if (!container) {
		container = document.createElement('div');
		container.id = DEFAULT_MODAL_CONTAINER_ID;

		document.body.appendChild(container);
	}

	root = render(
		<SimpleInputModal
			alert={alert}
			buttonSubmitLabel={buttonSubmitLabel}
			center={center}
			checkboxFieldLabel={checkboxFieldLabel}
			checkboxFieldName={checkboxFieldName}
			checkboxFieldValue={checkboxFieldValue}
			closeModal={cleanUp}
			dialogTitle={dialogTitle}
			formSubmitURL={formSubmitURL}
			idFieldName={idFieldName}
			idFieldValue={idFieldValue}
			initialVisible={true}
			mainFieldComponent={mainFieldComponent}
			mainFieldLabel={mainFieldLabel}
			mainFieldName={mainFieldName}
			mainFieldPlaceholder={mainFieldPlaceholder}
			mainFieldValue={mainFieldValue}
			method={method}
			namespace={namespace}
			onFormSuccess={onFormSuccess}
			required={required}
			size={size}
		/>,
		DEFAULT_RENDER_DATA,
		container
	);
}

let didEmitDeprecationWarning = false;

/**
 * Function that implements the SimpleInputModal pattern, which allows
 * manipulating small amounts of data with a form shown inside a modal.
 *
 * @deprecated As of Athanasius (7.3.x), replaced by the default export
 */
export function openSimpleInputModal(data: SimpleInputModalProps) {
	if (process.env.NODE_ENV === 'development' && !didEmitDeprecationWarning) {
		console.warn(
			'The named "openSimpleInputModal" export is deprecated: use the default export instead'
		);

		didEmitDeprecationWarning = true;
	}

	return openSimpleInputModalImplementation.call(null, data);
}
